import {SAMPLER, INSTRUMENT} from 'constants/track-types.js';
import {deleteAutomationsForParameters} from 'actions/index.js';
import {
    SAMPLED_INSTRUMENT,
    SYNTH,
    MULTI_SYNTH,
    FM_SYNTH,
    METAL_SYNTH,
    EXTERNAL_INSTRUMENT,
} from 'constants/instrument-types.js';

export default superclass => class extends superclass  {
    async convertToSampledInstrument() {
        let track = this.sequencerEngine.addSampledInstrumentTrack(false, true);
        let sample = this.sample;
        track.instrument.newSample(0, sample, this.samplesStream.getCopy(this.sample));
        this.convertGenericTrack(track);
        track.sample = sample;
    }

    async copyPatterns(track) {
        let patterns = this.patterns.map(pattern => pattern.getCopy(undefined, undefined, track));
        patterns = await Promise.all(patterns);
        for (let i in patterns) {
            let p = patterns[i];
            for (let j in p.stepBuckets) {
                p.stepBuckets[j].track = track;
                for (let k in p.stepBuckets[j].steps) {
                    p.stepBuckets[j].steps[k].track = track;
                }
            }
            p.track = track;
        }
        return patterns; 
    }

    async copyEffects(track) {
        let effectsJson = this.effectsChain.getJson();
        /*
        if (track.tracks) {
            track = track.tracks[0].track;
        }
        */
        await track.midiEffects.fromJson(
            this.midiEffects.getJson());
        await track.effectsChain.fromJson(
            effectsJson, this.sequencerEngine.tracks, this.trackNumber);
    }

    async convertGenericTrack(track) {
        track.patterns = await this.copyPatterns(track);
        track.pattern = track.patterns[this.currentPattern];
        track.stepGroups = track.patterns.map(x => x.getAllGroups()).reduce(
            (a,b) => [...a,...b], []);
 
        let trackNumberToDelete = this.trackNumber;
        let {tracks} = this.sequencerEngine;
        tracks.splice(trackNumberToDelete, 1);

        // get rid of automations
        let _parameters = this.getAllParameters();
        let _automationParameters = _parameters
            .filter(x => x.automations && x.automations.length > 0);
        this.sequencerEngine.store.dispatch(
            deleteAutomationsForParameters(_automationParameters));
 
        await this.copyEffects(track); 
        this.sequencerEngine.tracks = [
            ... tracks.slice(0, trackNumberToDelete),
            this,
            ... tracks.slice(trackNumberToDelete)];
        this.sequencerEngine.deleteTrack(trackNumberToDelete, track);

        track.pattern.updateStepResolutionTree();
        // delete any automations for this one...
        this.sequencerEngine.updateSteps();
        this.sequencerEngine.selectTrack(trackNumberToDelete);

        let  parameters = track.getAllParameters();
        let automationParameters = parameters
            .filter(x => x.automations && x.automations.length > 0);
        automationParameters.forEach(
            param => param.automation.updateRedux());
        
        setTimeout(() => {
            if (track.tracks) {
                track.tracks[0].track.loadLostParameters();
            } else {
                track.loadLostParameters();
            }
        }, 250);
    }

    async convertToInstrumentRack() {
        let track = this.sequencerEngine.addInstrumentRackTrack(false, true);
        let trackType = this.getTrackType();
        if (trackType === SAMPLER) {
            track.addSample(this.sample, this.samplesStream.getCopy(this.sample));
        } else if (trackType === INSTRUMENT) {
            let subTrack = track.addInstrumentType(this.getInstrumentType());
            let json = this.getJson();
            await subTrack.track.fromJson(json, undefined, false, false, true, true);
        }
        await this.convertGenericTrack(track);

    }
}
